export const menuSections = [
  {
    id: "starters",
    title: "מנות היכרות",
    items: [
      { name: "קלאסי", sizes: "200 / 300 / 400 ג׳", price: "43 / 51 / 59 ₪", desc: "בורגר בקר בליווי ירקות טריים" },
      { name: "אנגוס", sizes: "200 / 400 ג׳", price: "47 / 63 ₪", desc: "בשר אנטריקוט אנגוס מובחר, מוגש בליווי ירקות טריים" },
      { name: "בורגר שניצלונים", sizes: "120 ג׳", price: "37 ₪", desc: "שניצלונים בליווי ירקות טריים" },
      { name: "מיני בורגר", price: "34 ₪", desc: "המבורגר לקטנטנים בליווי ירקות" },
    ],
  },
  {
    id: "sides",
    title: "תוספות",
    items: [
      { name: "ציפס", price: "13 / 21 ₪" },
      { name: "טבעות בצל", price: "13 / 21 ₪" },
      { name: "ציפס בטטה", price: "16 / 28 ₪" },
      { name: "כדורי פירה", price: "16 / 28 ₪" },
      { name: "שניצלונים וציפס", price: "31 ₪" },
      { name: "שניצלונים", price: "21 / 35 ₪" },
      { name: "מיקס מטוגנים ענק", price: "31 ₪", desc: "מגיע עם ציפס, טבעות בצל ושניצלונים" },
    ],
  },
  {
    id: "toppings",
    title: "תוספות מעל",
    items: [
      { name: "בצל מטוגן", price: "5 ₪" },
      { name: "פטריות", price: "8 ₪" },
      { name: "חלפיניו", price: "6 ₪" },
      { name: "ריבת בצל", price: "10 ₪" },
      { name: "ביצת עין", price: "7 ₪" },
      { name: "אווז מעושן", price: "13 / 23 ₪" },
      { name: "חמאת בוטנים", price: "8 ₪" },
      { name: "אסאדו מפורק", price: "18 / 34 ₪" },
    ],
  },
  {
    id: "wraps",
    title: "טורטיות",
    items: [
      { name: "טורטיה הבית", price: "44 ₪", desc: "120 ג׳ בקר, אווז מעושן וריבת בצל בליווי ירקות טריים ורוטב הבית" },
      { name: "טורטיה שניצל", price: "34 ₪", desc: "120 ג׳ שניצל עם רוטב הבית בליווי ירקות טריים" },
      { name: "טורטיה בקר קצוץ", price: "36 ₪", desc: "120 ג׳ בקר על הפלנצ'ה בטיבול הבית, בליווי ירקות טריים" },
      { name: "טורטיה אנטריקוט", price: "37 ₪", desc: "120 ג׳ אנטריקוט עסיסי בליווי ירקות טריים ורוטב הבית" },
      { name: "טורטיה צימחונית", price: "29 ₪", desc: "חביתה עם בצל מטוגן ופטריות בליווי ירקות טריים" },
    ],
  },
  {
    id: "specials",
    title: "המיוחדים",
    items: [
      { name: "ביג מיורקו", price: "93 ₪", desc: "400 ג׳ בקר + 200 ג׳ אנטריקוט, אסאדו מפורק, ביצת עין ובצל מטוגן" },
      { name: "קרייזי מיה", price: "61 ₪", desc: "400 ג׳ אנטריקוט, אווז מעושן, בצל מטוגן וחמאת בוטנים" },
      { name: "קצין צהוב", price: "59 ₪", desc: "200 ג׳ אנטריקוט, חלפיניו ואווז מעושן" },
      { name: "מנת הבית", price: "59 ₪", desc: "200 ג׳ בקר, אווז מעושן, ריבת בצל ורוטב קארי" },
    ],
  },
  {
    id: "drinks",
    title: "שתייה",
    items: [
      { name: "בקבוק גדול 1 ליטר", price: "12 ₪" },
      { name: "פחית", price: "9 ₪" },
      { name: "מים / סודה", price: "6 ₪" },
    ],
  },
];
